<template>
  <div class="mt-3">
    <b-row>
      <b-col>
        <div class="mt-1">
          <span class="pagination-indicator">
            {{ pageFirstItem }}-{{ pageLastItem }} of
            {{ pagination.maxPage }}
            page{{ pagination.maxPage > 1 ? "s" : "" }}
          </span>
          <b-pagination
            hide-goto-end-buttons
            align="left"
            :limit="3"
            size="md"
            class="custom-pagination-arrow-only mb-0 ml-2"
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="pagination.currentPage"
            @change="paginate"
          >
          </b-pagination>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  props: {
    isInventoryByProduct: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("products", ["inventoryList", "pagination"]),
    ...mapFields("products", ["pagination"]),
    perPage() {
      if (this.pagination.maxPage === this.pagination.currentPage)
        return this.isInventoryByProduct ? 10 : 15;

      return this.isInventoryByProduct && this.inventoryList.length
        ? this.inventoryList[0].inventories.length
        : this.inventoryList.length;
    },
    pageFirstItem() {
      return this.perPage
        ? this.perPage * this.pagination.previousPage + 1
        : 0;
    },
    pageLastItem() {
      return this.pageFirstItem > 0
        ? this.pageFirstItem + this.perPage - 1
        : 0;
    },
    totalRows() {
      return this.perPage && this.perPage > 0
        ? this.pagination.maxPage * this.perPage
        : 1;
    },
  },
  methods: {
    paginate(page) {
      this.pagination.currentPage = page;
      this.$emit("getInventoryList");
    },
  },
};
</script>
